import { render, staticRenderFns } from "./AppointmentCard.vue?vue&type=template&id=32ed2faa&scoped=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCard.vue?vue&type=style&index=0&id=32ed2faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed2faa",
  null
  
)

export default component.exports